import {
  SPECIFIED_DATE_RANGE_JSON_DATA,
  COMPARISON_DATE_JSON_DATA,
  FORMAT_RESULT_JSON_DATA,
  EXPORT_REPORT_TYPE_DATA,
  MEASURES_SELECTION_MODAL_SHOW,
  CALCULATE_COMPARISON,
  RETAIL_MEASURES_MODAL_SHOW,
  RETAIL_METRICS_MEASURES_DATA,
  DASHBOARD_SEARCH_DATA,
  JSON_TO_EXCEL_DATA
} from "../../constants/ActionTypes";
import { Period } from "../../constants/Period";

const initialSettings = {
  specifiedDateRangeData: {},
  comparisonDateData: {},
  formatResultData: {},
  exportReportType: "xlsx",
  measureSelectionModalShow: false,
  getCalculatedComparison: 0,
  retailMeasuresModal: false,
  retailMetricsMeasureData: [],
  dashboardSearchData: 
    {
      OutletID :  "0",
      PeriodID : Period.Week.toString(),
    }
  ,
  jsonToExcelData : []
};

const Reports = (state = initialSettings, action) => {
  switch (action.type) {
    case SPECIFIED_DATE_RANGE_JSON_DATA:
      return {
        ...state,
        specifiedDateRangeData: action.payload,
      };

    case COMPARISON_DATE_JSON_DATA:
      return {
        ...state,
        comparisonDateData: action.payload,
      };
    case FORMAT_RESULT_JSON_DATA:
      return {
        ...state,
        formatResultData: action.payload,
      };
    case EXPORT_REPORT_TYPE_DATA:
      return {
        ...state,
        exportReportType: action.payload,
      };
    case MEASURES_SELECTION_MODAL_SHOW:
      return {
        ...state,
        measureSelectionModalShow: action.payload,
      };
    case CALCULATE_COMPARISON:
      return {
        ...state,
        getCalculatedComparison: action.payload,
      };
    case RETAIL_MEASURES_MODAL_SHOW:
      return {
        ...state,
        retailMeasuresModal: action.payload,
      };
    case RETAIL_METRICS_MEASURES_DATA:
      return {
        ...state,
        retailMetricsMeasureData: action.payload,
      };
    case DASHBOARD_SEARCH_DATA:
      return {
        ...state,
        dashboardSearchData: action.payload,
      };
      case JSON_TO_EXCEL_DATA:
        return {
          ...state,
          jsonToExcelData: action.payload,
        };
      

    default:
      return state;
  }
};

export default Reports;
